<table class="table">
<tr>
   <td> Names </td>
   <td> {{syncDetail['names']}} </td>
</tr>
<tr>
    <td> Date Created</td>
    <td>{{syncDetail['datecreated']}}  </td>
 </tr>
 <tr>
   <td> Request</td>
   <td>{{syncRequest}}  </td>
</tr>
<tr>
   <td> Response</td>
   <td>{{syncResponse}}  </td>
</tr>
</table>